/**
 * Created by piotr.pozniak@thebeaverhead.com on 30/06/2025.
 */
import React, { useCallback, useMemo } from "react";
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import { PLANS } from "../../../../consts";
import OrganizationSubscriptionLink from "./OrganizationSubscriptionLink";

const FreePlanSummary = ({ onUpdatePlan, onShowBillingHistory, disabled }) => {
  const { currentOrganization } = useCurrentOrganizationStore();
  const currentSubscription = currentOrganization.subscription;
  const hadTrial = useMemo(
    () =>
      currentOrganization.model.organizations_plans.find((i) => i.is_trial) !==
      undefined,
    [currentOrganization]
  );

  const onClickCallback = useCallback(
    (callback) => (e) => {
      e.preventDefault();
      if (disabled) {
        return;
      }

      callback();
      return false;
    },
    [disabled]
  );

  if (!currentSubscription || currentSubscription.code !== PLANS.free) {
    return null;
  }

  const hasBillingHistory = currentOrganization.model.organizations_plans?.find(
    (i) => i.stripe_subscription_id
  );

  const showPaymentHistory = hasBillingHistory ? (
    <p>
      <br />
      <OrganizationSubscriptionLink
        label={"Show payments history"}
        onClick={onClickCallback(onShowBillingHistory)}
        disabled={disabled}
      />
    </p>
  ) : null;

  return (
    <div className="row">
      <div className="col-12">
        <div className="card-box">
          <h4 className={"card-title d-flex gap-xs"}>
            <span>{currentSubscription.name}</span>
            <span className={`badge badge-info`}>FREE</span>
          </h4>
          <p className={""}>Subscription is valid indefinitely.</p>
          <button className="btn btn-primary" onClick={onUpdatePlan}>
            {hadTrial ? "Upgrade" : "Start 30 days free trial"}
          </button>
          {showPaymentHistory}
        </div>
      </div>
    </div>
  );
};

export default FreePlanSummary;
